import { FormatHeader6Icon } from './FormatHeader6Icon';

/**
 * author: Austin Andrews
 * id 854D0158-05E0-47A7-8E6E-2F66DCD415EE
 * name format-header-6
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-header-6.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHeading6Icon = FormatHeader6Icon;
export default FormatHeading6Icon